export enum Category {
    INPUT = "input",
    OUTPUT = "output",
    COMPETENCIES = "competencies",
    EVALSUMMARY = 'evalsummary',
    COMMENTS = "comments",
    UNSET = "unset"
}